'use client';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import clsx from 'clsx';
import {
  SvgAbout,
  SvgServices,
  SvgDoctors,
  SvgContacts,
  SvgPromotions,
  SvgLicenses,
  SvgNews,
  SvgAnalyses,
} from '@/components/icons';
import type { NavProps, IconsData } from './navbar.types';
import s from './navbar.module.scss';

const iconsMap: IconsData = {
  about: <SvgAbout />,
  services: <SvgServices />,
  doctors: <SvgDoctors />,
  licenses: <SvgLicenses />,
  news: <SvgNews />,
  promotions: <SvgPromotions />,
  analyses: <SvgAnalyses />,
  contacts: <SvgContacts />,
};

export const Navbar = ({ menuItems, theme, className }: NavProps) => {
  const pathname = usePathname();

  return (
    <nav
      className={clsx(s.bar, className)}
    >
      <ul className={clsx(s.list, { [s[theme]]: theme })}>
        {menuItems.map((item) => {
          if (item.isHidden) return null;

          const isActive = theme === 'tabs' ? pathname === item.path : pathname.includes(item.path);
          const itemClass = item.isSpecial
            ? (isActive ? s.active : s.specialLink)
            : (isActive ? s.active : s.link);

          return (
            <li key={item.id} className={clsx(s.listItem, { [s.hidden]: item.isHidden })}>
              <Link
                scroll={theme === 'footer'}
                href={item.path}
                className={itemClass}
              >
                {item.icon in iconsMap && iconsMap[item.icon]}{item.title}
              </Link>
            </li>
          );
        })}
      </ul>
    </nav>
  );
};